import {AbstractFilter} from '@gongxigames/framework/slot';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';

export class RubyCoinFilter extends AbstractFilter {
    public filter(response: Message): boolean {
        const spin = (this.getSpin(response) as WolfHavenSpin);

        return this.countSymbolsById(spin.symbolIds) > 0;
    }

    protected countSymbolsById(symbolIds: number[][]): number {
        let symbolsCount = 0;

        symbolIds.forEach(reel => {
            symbolsCount += reel.filter(symbol => symbol === WolfHaven.Ruby).length;
        });

        return symbolsCount;
    }
}
